import { render, staticRenderFns } from "./EventsTable.vue?vue&type=template&id=e491e142&scoped=true&"
import script from "./EventsTable.vue?vue&type=script&lang=ts&"
export * from "./EventsTable.vue?vue&type=script&lang=ts&"
import style0 from "./EventsTable.vue?vue&type=style&index=0&id=e491e142&scoped=true&lang=css&"
import style1 from "./EventsTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e491e142",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/cypher.team.viz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e491e142')) {
      api.createRecord('e491e142', component.options)
    } else {
      api.reload('e491e142', component.options)
    }
    module.hot.accept("./EventsTable.vue?vue&type=template&id=e491e142&scoped=true&", function () {
      api.rerender('e491e142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AddLossModal/EventsTable.vue"
export default component.exports